<template>
  <div class="sub-title mt-[30px]">
    {{ infoTitleModelValue }}
  </div>
  <div class="term-content">
    <div v-if="infoTrafficContentModelValue"
         class="traffic">
      <svg-icon name="railway"
                size="20"
                class="mr-1"></svg-icon>
      {{ infoTrafficContentModelValue }}
    </div>
    {{ infoContentModelValue }}
  </div>
</template>
<script setup
        lang="ts">


const infoTitleModelValue = defineModel('infoTitle', { type: String, default: '' });
const infoTrafficContentModelValue = defineModel('infoTrafficContent', { type: String, default: '' });
const infoContentModelValue = defineModel('infoContent', { type: String, default: '' });



</script>
<style scoped
       lang="scss">
.traffic {
  @apply flex items-center mb-[4px] text-[16px] text-black;
  img {
    @apply w-[20px] h-[20px] mr-[4px];
  }
}
.term-content {
  @apply pl-2 text-[16px] text-osn-grey-00 whitespace-pre-line;
}

</style>
